import * as React from "react";

import { AddButton } from "./AddButton";
import { FileLoaderContainer as FileLoader } from "./FileLoaderContainer";
import { ReplaceButton } from "./ReplaceButton";
import { RemoveButton } from "./ViewFile/RemoveButton";
import { ViewFileContainer as ViewFile } from "./ViewFile/ViewFileContainer";

interface Props {
    children: React.ReactChild[];
}

export function Menu(props: Props): JSX.Element {
    return <span>{props.children}</span>;
}

export function AddLine(props: Props): JSX.Element {
    return <span>{props.children}</span>;
}

export function ReplaceLine(props: Props): JSX.Element {
    return <span>{props.children}</span>;
}

// @ts-ignore
FileLoader.AddButton = AddButton;
// @ts-ignore
FileLoader.ReplaceButton = ReplaceButton;
// @ts-ignore
FileLoader.RemoveButton = RemoveButton;
// @ts-ignore
FileLoader.ViewFile = ViewFile;
// @ts-ignore
FileLoader.Menu = Menu;
// @ts-ignore
FileLoader.AddLine = AddLine;
// @ts-ignore
FileLoader.ReplaceLine = ReplaceLine;

export { FileLoader };
